import { get } from "../../utils/BaseService";

export async function getAllTDSDetails(dispatch: any,input:{residentStatus:string}) {
   return await get(dispatch, '/tds-details/getAllTDSDetails',input)
}